var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('CTableWrapper',{attrs:{"items":_vm.getShuffledUsersData(),"hover":"","striped":"","small":"","fixed":"","caption":"Listagem"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }